"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cashBalancePointerConfig = exports.cashBalanceFeedPointerMethod = exports.mapRampCashBalanceCsvToStandardCsv = void 0;
const assert_1 = __importDefault(require("assert"));
const lodash_1 = __importDefault(require("lodash"));
const finley_types_1 = require("@finley-technologies/finley-types");
const mapCsvToBorrowerCashBalancesFeed_1 = require("../mapCsvToBorrowerCashBalancesFeed");
// Map from Ramp-uploaded cash balances CSV to standard borrower cash balances CSV
const mapRampCashBalanceCsvToStandardCsv = (csvArray, reportingDate) => {
    const rampCashBalancesMap = {
        spv_cash_balance: finley_types_1.Bank.BorrowerAccountType.Collections,
        mmf_cash_balance: finley_types_1.Bank.BorrowerAccountType.PermittedInvestmentsAccount,
    };
    // Reduces csvArray down to Ramps borrowingBaseCashAccounts (spvCashBalance and cardProgramReserve)
    const rampCashBalanceRows = lodash_1.default.filter(csvArray, (row) => {
        // currentDebtOutstanding is not in ramp cash balances map
        if (!rampCashBalancesMap[row.balance_type]) {
            return false;
        }
        return true;
    });
    return lodash_1.default.map(rampCashBalanceRows, (row) => {
        const balanceType = rampCashBalancesMap[row.balance_type];
        (0, assert_1.default)(balanceType, `Ramp cash balances mapped ${row.balance_type} correctly to ${balanceType}`);
        return {
            facility_id: row.facility_id,
            reportingDate,
            balance_type: balanceType,
            balance: row.balance,
            refresh_date: reportingDate,
        };
    });
};
exports.mapRampCashBalanceCsvToStandardCsv = mapRampCashBalanceCsvToStandardCsv;
const cashBalanceFeedPointerMethod = ({ borrowerId, csvArray, reportingDate, fileVersion, creditFacilityId, }) => {
    const mappedCsvArray = (0, exports.mapRampCashBalanceCsvToStandardCsv)(csvArray, reportingDate);
    return (0, mapCsvToBorrowerCashBalancesFeed_1.mapCsvToBorrowerCashBalancesFeed)({
        borrowerId,
        csvArray: mappedCsvArray,
        reportingDate,
        fileVersion,
        creditFacilityId,
    });
};
exports.cashBalanceFeedPointerMethod = cashBalanceFeedPointerMethod;
exports.cashBalancePointerConfig = {
    pointer: 'rampGoldmanSachs1',
    method: exports.cashBalanceFeedPointerMethod,
};
//# sourceMappingURL=cashBalanceFeedPointerMethod.js.map